import { defineRecipe } from '@plurall/elo-v3';

export const feedbackAnalysisCardRecipe = defineRecipe({
  className: 'feedback-analysis__card-root',
  base: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    '&::before': { pointerEvents: 'none' },

    // Ver performanceDashboardCard.recipe.ts: o `::before` mascarado do card ELO
    // vira um retângulo opaco na impressão.
    _print: {
      border: '1px solid var(--elo-colors-border-primary) !important',
      '&::before': { display: 'none' },
      '&::after': { display: 'none' },
    },
  },
});

export const feedbackAnalysisSectionRecipe = defineRecipe({
  className: 'feedback-analysis',
  base: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    gap: 'space.16',
    width: '100%',
    minWidth: 0,
  },
});

export const feedbackAnalysisHeaderRecipe = defineRecipe({
  className: 'feedback-analysis__header',
  base: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: 'space.16',
    paddingBottom: 'space.16',
  },
});

export const feedbackAnalysisTabListRecipe = defineRecipe({
  className: 'feedback-analysis__tab-list',
  base: {
    display: 'flex',
    gap: 'space.8',
    overflowX: 'auto',
    paddingBottom: 'space.4',
    marginBottom: 'space.16',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': { display: 'none' },
  },
});

export const feedbackAnalysisTabTriggerRecipe = defineRecipe({
  className: 'feedback-analysis__tab-trigger',
  base: {
    flexShrink: 0,
    height: '2rem !important',
    borderRadius: '9999px !important',
    cursor: 'pointer',
    border: '1px solid var(--elo-colors-border-tertiary)',
    background: 'var(--elo-colors-background-primary)',
    color: 'var(--elo-colors-text-primary)',
    paddingInline: 'var(--elo-spacing-space-8)',
    font: 'inherit',
    '&:hover:not([data-selected])': {
      background: 'var(--elo-colors-background-secondary)',
    },
    '&[data-selected]': {
      background: 'var(--elo-colors-background-brand) !important',
      color: 'var(--elo-colors-foreground-on-brand) !important',
      borderColor: 'var(--elo-colors-background-brand) !important',
    },
  },
});

export const feedbackAnalysisChartGridItemRecipe = defineRecipe({
  className: 'feedback-analysis__chart-grid-item',
  base: {
    flex: '1 1 300px',
    minWidth: 0,
    height: '100%',
    overflow: 'hidden',
    maxHeight: '559px',
    '@media (max-width: 768px)': { maxHeight: 'none' },
    // NÃO zerar a altura aqui: o ResponsiveContainer do Recharts mede este
    // container, e se ele ficar com altura automática a medida vira 0 e o
    // gráfico não é desenhado. Só liberamos o recorte e o ::before mascarado
    // (ver performanceDashboardCard.recipe.ts).
    _print: {
      maxHeight: 'none',
      overflow: 'visible',
      border: '1px solid var(--elo-colors-border-primary) !important',
      '&::before': { display: 'none' },
      '&::after': { display: 'none' },
    },
  },
});

export const feedbackAnalysisContentGridRecipe = defineRecipe({
  className: 'feedback-analysis__content-grid',
  base: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr)',
    gap: 'space.24',
    alignItems: 'stretch',
    alignSelf: 'stretch',
    minWidth: 0,
  },
});

export const feedbackAnalysisContentSingleRecipe = defineRecipe({
  className: 'feedback-analysis__content-single',
  base: {
    width: '100%',
    minWidth: 0,
  },
});

export const feedbackAnalysisStrengthsCardRecipe = defineRecipe({
  className: 'feedback-analysis__strengths-card',
  base: {
    '&::before': { pointerEvents: 'none' },
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    overflow: 'hidden',
    maxHeight: 'none',
    '& > *': {
      width: '100%',
      minWidth: 0,
    },
    '@media (min-width: 1200px)': {
      width: '100%',
      maxHeight: '559px',
    },
    // NÃO zerar a altura aqui: o ResponsiveContainer do Recharts mede este
    // container, e se ele ficar com altura automática a medida vira 0 e o
    // gráfico não é desenhado. Só liberamos o recorte e o ::before mascarado
    // (ver performanceDashboardCard.recipe.ts).
    _print: {
      maxHeight: 'none',
      overflow: 'visible',
      border: '1px solid var(--elo-colors-border-primary) !important',
      '&::before': { display: 'none' },
      '&::after': { display: 'none' },
    },
  },
});

export const feedbackAnalysisChartCardRecipe = defineRecipe({
  className: 'feedback-analysis__chart-card',
  base: {
    '&::before': { pointerEvents: 'none' },
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    maxHeight: 'none',
    '& > *': {
      width: '100%',
      minWidth: 0,
    },
    '@media (min-width: 1200px)': {
      width: '100%',
      maxWidth: '100%',
      height: '100%',
    },
    // NÃO zerar a altura aqui: o ResponsiveContainer do Recharts mede este
    // container, e se ele ficar com altura automática a medida vira 0 e o
    // gráfico não é desenhado. Só liberamos o recorte e o ::before mascarado
    // (ver performanceDashboardCard.recipe.ts).
    _print: {
      maxHeight: 'none',
      overflow: 'visible',
      border: '1px solid var(--elo-colors-border-primary) !important',
      '&::before': { display: 'none' },
      '&::after': { display: 'none' },
    },
  },
});

export const feedbackAnalysisPanelCardRecipe = defineRecipe({
  className: 'feedback-analysis__panel-card',
  base: {
    '&::before': { pointerEvents: 'none' },
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    maxHeight: '559px',
    '@media (max-width: 768px)': { maxHeight: 'none' },
    // NÃO zerar a altura aqui: o ResponsiveContainer do Recharts mede este
    // container, e se ele ficar com altura automática a medida vira 0 e o
    // gráfico não é desenhado. Só liberamos o recorte e o ::before mascarado
    // (ver performanceDashboardCard.recipe.ts).
    _print: {
      maxHeight: 'none',
      overflow: 'visible',
      border: '1px solid var(--elo-colors-border-primary) !important',
      '&::before': { display: 'none' },
      '&::after': { display: 'none' },
    },
  },
});

export const feedbackAnalysisEmptyStateRecipe = defineRecipe({
  className: 'feedback-analysis__empty-state',
  base: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 'space.8',
    padding: 'space.32',
    minHeight: '200px',
  },
});

export const feedbackAnalysisChartMobileListRecipe = defineRecipe({
  className: 'feedback-analysis__chart-mobile-list',
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.12',
  },
});

export const feedbackAnalysisChartMobileItemRecipe = defineRecipe({
  className: 'feedback-analysis__chart-mobile-item',
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.4',
  },
});

export const feedbackAnalysisChartMobileLabelRecipe = defineRecipe({
  className: 'feedback-analysis__chart-mobile-label',
  base: {
    fontSize: '12px',
    color: 'var(--elo-colors-text-primary)',
    fontWeight: 'var(--elo-font-weights-font-weight-medium)',
  },
});

export const feedbackAnalysisChartMobileBarRowRecipe = defineRecipe({
  className: 'feedback-analysis__chart-mobile-bar-row',
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: 'space.8',
  },
});

export const feedbackAnalysisChartMobileBarTrackRecipe = defineRecipe({
  className: 'feedback-analysis__chart-mobile-bar-track',
  base: {
    flex: 1,
    position: 'relative',
    height: '20px',
    borderRadius: 'var(--elo-radii-shape-4)',
    overflow: 'hidden',
  },
});

export const feedbackAnalysisChartMobileBarFillRecipe = defineRecipe({
  className: 'feedback-analysis__chart-mobile-bar-fill',
  base: {
    position: 'absolute',
    inset: 0,
    background: 'var(--elo-colors-background-feedback-warning-secondary)',
    borderRadius: 'var(--elo-radii-shape-4)',
  },
});

export const feedbackAnalysisChartMobileValueRecipe = defineRecipe({
  className: 'feedback-analysis__chart-mobile-value',
  base: {
    fontSize: '12px',
    color: 'var(--elo-colors-text-secondary)',
    flexShrink: 0,
    width: '28px',
    textAlign: 'right',
  },
});

export const feedbackAnalysisStrengthsRecipe = defineRecipe({
  className: 'feedback-analysis__strengths',
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.8',
    minWidth: 0,
    flex: 1,
    minHeight: 0,
  },
});

export const feedbackAnalysisStrengthItemsListRecipe = defineRecipe({
  className: 'feedback-analysis__strength-items-list',
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.8',
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': { display: 'none' },
  },
});

export const feedbackAnalysisStrengthsHeadingRecipe = defineRecipe({
  className: 'feedback-analysis__strengths-heading',
  base: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 'space.12',
    marginBottom: 'space.4',
  },
});

export const feedbackAnalysisStrengthsIconCardRecipe = defineRecipe({
  className: 'feedback-analysis__strengths-icon-card',
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '40px',
    height: '40px',
    flexShrink: 0,
    borderRadius: 'var(--elo-radii-shape-8)',
    background: 'var(--elo-colors-background-feedback-success-primary-alpha)',
  },
});

export const feedbackAnalysisStrengthsTextWrapperRecipe = defineRecipe({
  className: 'feedback-analysis__strengths-text-wrapper',
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.2',
    flex: 1,
    minWidth: 0,
  },
});

export const feedbackAnalysisStrengthsTitleRecipe = defineRecipe({
  className: 'feedback-analysis__strengths-title',
  base: {
    fontSize: 'var(--elo-font-sizes-font-size-small)',
    fontWeight: 'var(--elo-font-weights-font-weight-bold)',
    color: 'var(--elo-colors-text-primary)',
    lineHeight: '1.4',
  },
});

export const feedbackAnalysisStrengthsSubtitleRecipe = defineRecipe({
  className: 'feedback-analysis__strengths-subtitle',
  base: {
    fontSize: 'var(--elo-font-sizes-font-size-xsmall)',
    color: 'var(--elo-colors-text-secondary)',
    lineHeight: '1.4',
  },
});

export const feedbackAnalysisStrengthItemIconCardRecipe = defineRecipe({
  className: 'feedback-analysis__strength-item-icon-card',
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '23px',
    height: '23px',
    flexShrink: 0,
    borderRadius: '9999px',
    background: 'var(--elo-colors-background-feedback-success-primary-alpha)',
  },
});

export const feedbackAnalysisStrengthItemCardRecipe = defineRecipe({
  className: 'feedback-analysis__strength-item-card',
  base: {
    '&::before': { pointerEvents: 'none' },
    borderRadius: 'var(--elo-radii-shape-8) !important',
  },
});

export const feedbackAnalysisStrengthItemRowRecipe = defineRecipe({
  className: 'feedback-analysis__strength-item-row',
  base: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: 'space.8',
  },
});

export const feedbackAnalysisChartSectionRecipe = defineRecipe({
  className: 'feedback-analysis__chart-section',
  base: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.16',
    minWidth: 0,
  },
});

export const feedbackAnalysisChartHeadingRecipe = defineRecipe({
  className: 'feedback-analysis__chart-heading',
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: 'space.12',
    marginBottom: 'space.4',
  },
});

export const feedbackAnalysisChartIconCardRecipe = defineRecipe({
  className: 'feedback-analysis__chart-icon-card',
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '40px',
    height: '40px',
    flexShrink: 0,
    borderRadius: 'var(--elo-radii-shape-8)',
    background: 'var(--elo-colors-background-feedback-warning-primary-alpha)',
  },
});

export const feedbackAnalysisChartWrapperRecipe = defineRecipe({
  className: 'feedback-analysis__chart-wrapper',
  base: {
    width: '100%',
    minWidth: 0,
    '& .recharts-cartesian-axis-tick-value': {
      fontSize: '12px',
      fill: 'var(--elo-colors-text-secondary)',
    },
  },
});

export const feedbackAnalysisSkeletonRecipe = defineRecipe({
  className: 'feedback-analysis__skeleton',
  base: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 'space.16',
    flex: 1,
  },
});

export const feedbackAnalysisTabsSkeletonRecipe = defineRecipe({
  className: 'feedback-analysis__tabs-skeleton',
  base: {
    display: 'flex',
    gap: 'space.8',
  },
});

export const feedbackAnalysisGeneroWrapperRecipe = defineRecipe({
  className: 'feedback-analysis__genero-wrapper',
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: 'space.8',
    flexShrink: 0,
  },
});

export const feedbackAnalysisGeneroLabelRecipe = defineRecipe({
  className: 'feedback-analysis__genero-label',
  base: {
    fontSize: 'var(--elo-font-sizes-font-size-small)',
    color: 'var(--elo-colors-text-secondary)',
    whiteSpace: 'nowrap',
  },
});

export const feedbackAnalysisGeneroSelectRecipe = defineRecipe({
  className: 'feedback-analysis__genero-select',
  base: {
    flexShrink: 0,
    "& [data-scope='field'][data-part='root']": {
      width: '100% !important',
    },
    "& [data-scope='select'][data-part='root'], & [data-scope='select'][data-part='trigger']": {
      width: 'fit-content !important',
      minWidth: '140px',
    },
    "& [data-scope='select'][data-part='value-text']": {
      maxWidth: 'none !important',
    },
    "& [data-scope='select'][data-part='content'], & [data-scope='select'][data-part='positioner']": {
      minWidth: '100%',
    },
  },
});
